// @ts-nocheck
import { Suspense, lazy, useState } from "react";
import { Provider } from "react-redux";
import {
    Redirect,
    Route,
    BrowserRouter as Router,
    Switch,
} from "react-router-dom";
import store from "./store";

import { AssistanceRoute } from "./hocs/AssistanceRoute";
import { BranchManagerRoute } from "./hocs/BranchManagerRoute";
import { FieldWorkerRoute } from "./hocs/FieldWorkerRoute";
import { PrivateRoute } from "./hocs/PrivateRoute";

import "bootstrap/dist/css/bootstrap.min.css";
import "./hocs/@fortawesome/fontawesome-free/css/all.min.css";
import Layout from "./hocs/Layout";
import "./hocs/css/light.css";
import "./hocs/css/style.css";

import Home from "./containers/PublicPages/Home";
import { AdminRoute } from "./hocs/AdminRoute";
import { AuthRoute } from "./hocs/AuthRoute";
import { PublicRoute } from "./hocs/PublicRoute";
import { SalesRepresentativeRoute } from "./hocs/SalesRepresentativeRoute";

// Load each screen only when its route is rendered. Keep Home eager for first paint.
const BusinessProfiles = lazy(() => import("./containers/CeoPages/BusinessProfiles"));
const EmployeeMain = lazy(() => import("./containers/CeoPages/Employee/EmployeeMain"));
const Block = lazy(() => import("./containers/PublicPages/Block"));
const Activate = lazy(() => import("./containers/PublicPages/Login_Reg_View/Activate"));
const Facebook = lazy(() => import("./containers/PublicPages/Login_Reg_View/Facebook"));
const Google = lazy(() => import("./containers/PublicPages/Login_Reg_View/Google"));
const Login = lazy(() => import("./containers/PublicPages/Login_Reg_View/Login"));
const ResetPassword = lazy(() => import("./containers/PublicPages/Login_Reg_View/ResetPassword"));
const ResetPasswordConfirm = lazy(() => import("./containers/PublicPages/Login_Reg_View/ResetPasswordConfirm"));
const NotFound = lazy(() => import("./containers/PublicPages/NotFound"));

const LoadPending = lazy(() => import("./containers/AuthPages/LoadPending"));
const PendingUser = lazy(() => import("./containers/AuthPages/PendingUser"));
const Register = lazy(() => import("./containers/AuthPages/Register"));
const WaitingUsers = lazy(() => import("./containers/PublicPages/Login_Reg_View/WaitingUsers"));

const CreateCompany = lazy(() => import("./containers/AuthPages/Admin/CreateCompany"));
const CreateBranch = lazy(() => import("./containers/CeoPages/CreateBranch"));
const UpdateBranch = lazy(() => import("./containers/CeoPages/UpdateBranch"));

//Profiles
const MyUserLists = lazy(() => import("./containers/AuthPages/Profiles/MyUserLists"));
const Profiles = lazy(() => import("./containers/AuthPages/Profiles/Profiles"));

//BusinessProfiles
const BusinessPro = lazy(() => import("./containers/AuthPages/Profiles/BisProfile/BisMain"));

// Suppliers
// National Suppliers
const ProductItems = lazy(() => import("./containers/Suppliers/NationalSuppliers/Profiles/ProductItems"));
const SupplierPro = lazy(() => import("./containers/Suppliers/NationalSuppliers/Profiles/SupplierMain"));
const NationalSuppliers = lazy(() => import("./containers/Suppliers/NationalSuppliers/SupplierLists"));
const SupplierReg = lazy(() => import("./containers/Suppliers/Register"));

// My Suppliers
const MySupplierMain = lazy(() => import("./containers/Suppliers/MySuppliers/Profiles/SupplierMain"));
const MySupplierList = lazy(() => import("./containers/Suppliers/MySuppliers/SupplierLists"));

// My Party
const PaymentReceived = lazy(() => import("./containers/Accounts/PaymentReceipt/PayemntReceived"));

// Purchase
const DocketPurchase = lazy(() => import("./containers/Inventory/Purchase/DocketPurchase"));
const PurchaseProduct = lazy(() => import("./containers/Inventory/Purchase/PurchaseProduct"));
const SupplierList = lazy(() => import("./containers/Inventory/Purchase/SupplierLists"));

// Daily Sell

// Stock
const CounterStock = lazy(() => import("./containers/AuthPages/Counter/CounterStock"));
const Stock = lazy(() => import("./containers/Inventory/Stock/Stock"));

// Accounts
const AccountJournal = lazy(() => import("./containers/Accounts/AccountJournal"));
const COA = lazy(() => import("./containers/Accounts/COA"));
const Ledger = lazy(() => import("./containers/Accounts/Ledger/Ledger"));
const Voucher = lazy(() => import("./containers/Accounts/Voucher/Voucher"));

const Backup = lazy(() => import("./containers/AuthPages/Admin/Backup"));
const BisList = lazy(() => import("./containers/AuthPages/Admin/BisList"));
const UserLists = lazy(() => import("./containers/AuthPages/Admin/UserLists"));
const Counters = lazy(() => import("./containers/AuthPages/Counter/Counters"));
const ZReading = lazy(() => import("./containers/AuthPages/Counter/ZReading"));
const Wellcome = lazy(() => import("./containers/AuthPages/LandingPage/Wellcome"));
const UpdateUser = lazy(() => import("./containers/AuthPages/Profiles/UpdateUser"));
const ResetPass = lazy(() => import("./containers/AuthPages/ResetPass"));
const CashLadger = lazy(() => import("./containers/CashFlow/CashLadger"));
const CountersSettings = lazy(() => import("./containers/Settings/CountersSettings"));

const PurchaseReport = lazy(() => import("./containers/Inventory/PurchaseReport/PurchaseReport"));
// Purchase Order module (containers)
const ProductRequisition = lazy(() => import("./containers/Inventory/Requisitions/ProductRequisition"));
const ReqExecute = lazy(() => import("./containers/Inventory/Requisitions/ReqExecute"));
const RequisitionDraft = lazy(() => import("./containers/Inventory/Requisitions/RequisitionDraft"));
const RequisitionHistory = lazy(() => import("./containers/Inventory/Requisitions/RequisitionHistory"));
const RequisitionList = lazy(() => import("./containers/Inventory/Requisitions/RequisitionList"));
const SellReport = lazy(() => import("./containers/Inventory/SellReport/SellReport"));
const PartyMain = lazy(() => import("./containers/Party/MyParty/BisProfile/PartyMain"));
const PartyLists = lazy(() => import("./containers/Party/MyParty/PartyLists"));
const PartyReg = lazy(() => import("./containers/Party/PartyReg"));
const Disable = lazy(() => import("./containers/PublicPages/Disable"));

const ViewPurchase = lazy(() => import("./containers/Suppliers/MySuppliers/Profiles/ViewInvoice/ViewPurchase"));
const CounterSellReport = lazy(() => import("./containers/Trading/CounterSellReport/CounterSellReport"));
const Parties = lazy(() => import("./containers/Trading/Parties"));
const Order = lazy(() => import("./containers/Trading/SaleOrder/Order"));
const OrderExecute = lazy(() => import("./containers/Trading/SaleOrder/OrderExecute"));
const OrderList = lazy(() => import("./containers/Trading/SaleOrder/OrderList"));

// Quotation
const EditQuote = lazy(() => import("./containers/Trading/Quotation/EditQuote"));
const QuoteList = lazy(() => import("./containers/Trading/Quotation/QuotationList"));
const Quote = lazy(() => import("./containers/Trading/Quotation/Quote"));
const QuoteOrder = lazy(() => import("./containers/Trading/Quotation/QuoteOrder"));
const QuotePreview = lazy(() => import("./containers/Trading/Quotation/QuotePreview"));
const QuoteSale = lazy(() => import("./containers/Trading/Quotation/QuoteSale"));

// Purchase Order
const EditPursOrder = lazy(() => import("./containers/Trading/PurchaseOrder/EditPursOrder"));
const PursOrder = lazy(() => import("./containers/Trading/PurchaseOrder/PursOrder"));
const PursOrderList = lazy(() => import("./containers/Trading/PurchaseOrder/PursOrderList"));

// Yard
const ContainerList = lazy(() => import("./containers/Yard/ContainerList"));
const ContainerSummery = lazy(() => import("./containers/Yard/ContainerSummery/ContainerSummery"));
const CtrPurchase = lazy(() => import("./containers/Yard/CtrPurchase"));
const DeliveryNoteList = lazy(() => import("./containers/Yard/Deliveries/DeliveryNoteList"));
const DeliveryNoteView = lazy(() => import("./containers/Yard/Deliveries/DeliveryNoteView"));
const DeliveryRequest = lazy(() => import("./containers/Yard/Deliveries/DeliveryRequest"));
const RequestExecute = lazy(() => import("./containers/Yard/Request/RequestExecute"));
const YardStock = lazy(() => import("./containers/Yard/YardStock"));

const PreviewInvoice = lazy(() => import("./containers/Trading/ViewInvoice/PreviewInvoice"));
const Transaction = lazy(() => import("./containers/Transactions/Transactions"));
const RequestList = lazy(() => import("./containers/Yard/Request/RequestList"));

//Statements
const BalanceSheet = lazy(() => import("./containers/Statements/BalanceSheet"));
const IncomeStatement = lazy(() => import("./containers/Statements/IncomeStatement"));
const TrialBalance = lazy(() => import("./containers/Statements/TrialBalance"));

//Reports
const BisSummery = lazy(() => import("./containers/Reports/BISSummery/BISSummery"));
const OrderedItems = lazy(() => import("./containers/Reports/OrderSummery/OrderedItems"));
const PartyAgedInvoiceList = lazy(() => import("./containers/Reports/PartyAged/PartyAgedInvoiceList"));
const ProductItemsAnalysis = lazy(() => import("./containers/Reports/ProductAnalysis/ProductItemsAnalysis"));
const SalesPerformanceReport = lazy(() => import("./containers/Reports/SalesPerformance/SalesPerformanceReport"));
const SoldOutItems = lazy(() => import("./containers/Reports/SoldOutSummery/SoldOutItems"));
const SupplierAgedInvoiceList = lazy(() => import("./containers/Reports/SupplierAged/SupplierAgedInvoiceList"));

//Reports
const TransactionHistory = lazy(() => import("./containers/Accounts/PeiBetaHistory/TxnHistory"));
const PriceChangeLog = lazy(() => import("./containers/Inventory/PriceChangeLog/PriceChangeLog"));
const ProfitabilityAssesment = lazy(() => import("./containers/Reports/ContainerProfitability/ProfitabilityAssesment"));
const GSTonPurchase = lazy(() => import("./containers/Reports/GSTonPurchase/GSTonPurchase"));
const GSTonSale = lazy(() => import("./containers/Reports/GSTonSale/GSTonSale"));
const NillStockItemUI = lazy(() => import("./containers/Reports/NillStockItems/NillStockItemUI"));
const CatByPL = lazy(() => import("./containers/Reports/PLByCat/CatByPL"));
const SalesPurchaseAnalysis = lazy(() => import("./containers/Reports/SalesPurchaseAnalysis/SalesPurchaseAnalysis"));
const UCSPartyInvoiceList = lazy(() => import("./containers/Reports/UCSPartyInvoice/UCSPartyInvoiceList"));
const UCSReport = lazy(() => import("./containers/Reports/UnderCostSaleReport/UCSReport"));

//Vendors & Providors
const VendorMain = lazy(() => import("./containers/VendorsNServices/Profiles/VendorMain"));
const VendorRegistration = lazy(() => import("./containers/VendorsNServices/Register"));
const VendorList = lazy(() => import("./containers/VendorsNServices/VendorList"));

//Payment Process
const CreateAdvice = lazy(() => import("./containers/PaymentProcess/AdviceForm/CreateAdvice"));
const AdviceList = lazy(() => import("./containers/PaymentProcess/ApprovedAdvice/AdviceList"));
const PaidInvoices = lazy(() => import("./containers/PaymentProcess/PaidInvoiceList/PaidInvoices"));
const RequestSubmission = lazy(() => import("./containers/PaymentProcess/PaymentRequest/RequestSubmission"));
const Requisition = lazy(() => import("./containers/PaymentProcess/PaymentRequest/Requisition"));
const PaymentRequestList = lazy(() => import("./containers/PaymentProcess/PaymentRequestList/RequestList/PaymentRequestList"));
const RequestViewer = lazy(() => import("./containers/PaymentProcess/PaymentRequestList/RequestView/RequestViewer"));
const PendingAdviceList = lazy(() => import("./containers/PaymentProcess/PendingAdvices/PendingAdviceList"));
const ProcureList = lazy(() => import("./containers/VendorsNServices/Procurement/ProcureList"));
const Procurement = lazy(() => import("./containers/VendorsNServices/Procurement/Procurement"));
const ViewProcure = lazy(() => import("./containers/VendorsNServices/Profiles/ViewInvoice/ViewProcure"));

// Promotion
const FOCDistributionSummary = lazy(() => import("./containers/Trading/Campaign/FOCTrading/FOCDistributionSummary"));
const FOCTradeItems = lazy(() => import("./containers/Trading/Campaign/FOCTrading/FOCTradeItems"));
const CreateFOCProgram = lazy(() => import("./containers/Trading/Campaign/PromotionalProgram/IssuePP"));
const FOCProgramEdit = lazy(() => import("./containers/Trading/Campaign/PromotionalProgram/PPEdit"));
const FOCProgramView = lazy(() => import("./containers/Trading/Campaign/PromotionalProgram/PPView"));
const FOCProgramsList = lazy(() => import("./containers/Trading/Campaign/PromotionalProgram/PPlist"));

// Lazy-loaded heavy routes
const Dashboard = lazy(
    () => import("./containers/AuthPages/Dashboard/Dashboard"),
);
const RetailSell = lazy(() => import("./containers/Trading/RetailSell"));
const Sells = RetailSell;

const App = () => {
    const pathname = window.location.pathname;
    const [list, setList] = useState([]);
    // const [ProductPro, setProductPro] = useState();
    const [SupplierID, setSupplierID] = useState();
    const [isActive, setActive] = useState(pathname === "/dashboard" ? 1 : "");

    return (
        <Provider store={store}>
            <Router>
                <Layout
                    list={list}
                    setList={setList}
                    setActive={setActive}
                    isActive={isActive}
                >
                    <Suspense fallback={<div role="status" style={{ padding: "2rem", textAlign: "center" }}>Loading page…</div>}>
                        <Switch>
                            <PublicRoute exact path="/" component={Home} render={undefined} />
                            <PublicRoute
                                exact
                                path="/home"
                                component={Home}
                                render={undefined}
                            />
                            <PublicRoute
                                exact
                                path="/login"
                                component={Login}
                                render={undefined}
                            />
                            <PublicRoute
                                exact
                                path="/block"
                                component={Block}
                                render={undefined}
                            />
                            <PublicRoute
                                exact
                                path="/disable"
                                component={Disable}
                                render={undefined}
                            />
                            <PublicRoute
                                exact
                                path="/disable"
                                component={Disable}
                                render={undefined}
                            />

                            <AuthRoute
                                exact
                                path="/wellcome"
                                render={(props) => (
                                    <Wellcome list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/waiting"
                                component={WaitingUsers}
                                render={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/dashboard"
                                component={Dashboard}
                                render={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/facebook"
                                component={Facebook}
                                render={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/google"
                                component={Google}
                                render={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/reset-password"
                                component={ResetPassword}
                                render={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/password/reset/confirm/:uid/:token"
                                component={ResetPasswordConfirm}
                                render={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/activate/:uid/:token"
                                component={Activate}
                                render={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/LoadPending"
                                component={LoadPending}
                                render={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/Register"
                                render={(props) => (
                                    <Register list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/pending_user"
                                component={PendingUser}
                                render={undefined}
                            />

                            {/* Counters */}
                            <PrivateRoute
                                path="/counter_list"
                                render={(props) => (
                                    <Counters list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                exact
                                path="/counter_settings"
                                render={(props) => <CountersSettings {...props} />}
                                component={undefined}
                            />
                            <SalesRepresentativeRoute
                                exact
                                path="/counter_sell"
                                render={(props) => (
                                    <RetailSell
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <SalesRepresentativeRoute
                                exact
                                path="/counter_stock"
                                render={(props) => (
                                    <CounterStock
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <SalesRepresentativeRoute
                                path="/counter_sale_report/:ctr_no/:date_from/:date_to"
                                render={(props) => (
                                    <CounterSellReport list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                exact
                                path="/sale_performance_report"
                                render={(props) => (
                                    <SalesPerformanceReport
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                exact
                                path="/z_reading"
                                render={(props) => (
                                    <ZReading list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Cash Flow */}
                            <PrivateRoute
                                path="/cash_flow"
                                render={(props) => (
                                    <CashLadger list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/transactions"
                                render={(props) => (
                                    <Transaction list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Accounts */}
                            <AssistanceRoute
                                path="/voucher"
                                render={(props) => (
                                    <Voucher list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/coa"
                                render={(props) => (
                                    <COA list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/acc_journal"
                                render={(props) => (
                                    <AccountJournal list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/ledger"
                                render={(props) => (
                                    <Ledger list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Profiles */}
                            <AssistanceRoute
                                exact
                                path="/my_user_lists"
                                component={MyUserLists}
                                render={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/user_profile/:id"
                                render={(props) => (
                                    <Profiles list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/update_user"
                                render={(props) => (
                                    <UpdateUser list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            <AssistanceRoute
                                exact
                                path="/business_profiles"
                                render={(props) => (
                                    <BusinessProfiles list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/employee_main/:id"
                                render={(props) => (
                                    <EmployeeMain list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/update_branch"
                                component={UpdateBranch}
                                render={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/create_branch"
                                render={(props) => (
                                    <CreateBranch list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Supplier AssistanceRoute */}
                            {/* National Suppliers */}
                            <AssistanceRoute
                                exact
                                path="/national_supplier_list"
                                render={(props) => (
                                    <NationalSuppliers list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/my_supplier_pro/:sup_id"
                                render={(props) => (
                                    <SupplierPro list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/product_item/:sup_id/:id"
                                render={(props) => (
                                    <ProductItems list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Supplier AssistanceRoute */}
                            {/* My Suppliers */}
                            <AssistanceRoute
                                exact
                                path="/my_supplier_list"
                                render={(props) => (
                                    <MySupplierList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/my_supplier/:sup_id"
                                render={(props) => (
                                    <MySupplierMain list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/supplier_reg"
                                render={(props) => (
                                    <SupplierReg list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/sup_aged_invoice_list"
                                render={(props) => (
                                    <SupplierAgedInvoiceList
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            {/* Supplier AssistanceRoute */}

                            {/* Party AssistanceRoute */}
                            {/* Party */}
                            <AssistanceRoute
                                exact
                                path="/my_party_list"
                                render={(props) => (
                                    <PartyLists list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/my_party/:party_id/:my_party_id"
                                render={(props) => (
                                    <PartyMain list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/party_reg"
                                render={(props) => (
                                    <PartyReg list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/payments"
                                render={(props) => (
                                    <PaymentReceived list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/party_aged_invoice_list"
                                render={(props) => (
                                    <PartyAgedInvoiceList
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />

                            {/* Party AssistanceRoute */}

                            {/* Inventory */}
                            {/* Purchase */}
                            <AssistanceRoute
                                exact
                                path="/supplier_items"
                                render={(props) => (
                                    <SupplierList
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/purchase_product/:sup_id"
                                render={(props) => (
                                    <PurchaseProduct
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/purchase_reports"
                                render={(props) => (
                                    <PurchaseReport list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            <AssistanceRoute
                                exact
                                path="/purchase_order"
                                render={(props) => (
                                    <PursOrder list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/purs_order_list"
                                render={(props) => (
                                    <PursOrderList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/po_edit/:po_id"
                                render={(props) => (
                                    <EditPursOrder list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/add_docket/:purs_id"
                                render={(props) => (
                                    <DocketPurchase list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Trading */}
                            {/* Order */}
                            <AssistanceRoute
                                exact
                                path="/parties"
                                render={(props) => (
                                    <Parties
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/order/:party_id"
                                render={(props) => (
                                    <Order list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/order_exc/:order_id"
                                render={(props) => (
                                    <OrderExecute list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/order_list"
                                render={(props) => (
                                    <OrderList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/ordered_items_list"
                                render={(props) => (
                                    <OrderedItems list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/sold_items_list"
                                render={(props) => (
                                    <SoldOutItems list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Quotation */}
                            <AssistanceRoute
                                exact
                                path="/parties"
                                render={(props) => (
                                    <Parties
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/quote"
                                render={(props) => (
                                    <Quote list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/quote_list"
                                render={(props) => (
                                    <QuoteList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/quote_preview/:qt_id"
                                render={(props) => (
                                    <QuotePreview list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/quote_edit/:qt_id"
                                render={(props) => (
                                    <EditQuote list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/quote_sale/:qt_id/:walk_in"
                                render={(props) => (
                                    <QuoteSale list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/quote_order/:qt_id/:party_id"
                                render={(props) => (
                                    <QuoteOrder list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            <AssistanceRoute
                                exact
                                path="/order_exc/:order_id"
                                render={(props) => (
                                    <OrderExecute list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            <AssistanceRoute
                                exact
                                path="/rtl_sell"
                                render={(props) => (
                                    <RetailSell
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/whl_sell"
                                render={(props) => (
                                    <Sells
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/sell_reports"
                                render={(props) => (
                                    <SellReport list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/sell_invoice_preview/:inv_id"
                                render={(props) => (
                                    <PreviewInvoice list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/purs_invoice_preview/:pur_id"
                                render={(props) => (
                                    <ViewPurchase list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Stock */}
                            <AssistanceRoute
                                exact
                                path="/stock"
                                render={(props) => (
                                    <Stock
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/item_analysis"
                                render={(props) => (
                                    <ProductItemsAnalysis
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/category_pl_report"
                                render={(props) => (
                                    <CatByPL
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />

                            {/* Bis Profile */}
                            <AssistanceRoute
                                path="/business_pro/:id/:bis_id"
                                render={(props) => (
                                    <BusinessPro list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Yard */}
                            <AssistanceRoute
                                path="/ctr_list"
                                render={(props) => (
                                    <ContainerList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/ctr_summary/:id"
                                render={(props) => (
                                    <ContainerSummery list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/ctr_purchase"
                                render={(props) => (
                                    <CtrPurchase list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/yard"
                                render={(props) => (
                                    <YardStock list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/yard_request"
                                render={(props) => (
                                    <DeliveryRequest list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/request_list"
                                render={(props) => (
                                    <RequestList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/request_exc/:id"
                                render={(props) => (
                                    <RequestExecute list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/delivery_notes"
                                render={(props) => (
                                    <DeliveryNoteList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/delivery_note_view/:id"
                                render={(props) => (
                                    <DeliveryNoteView list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Statements */}
                            <AssistanceRoute
                                path="/inc_statement"
                                render={(props) => (
                                    <IncomeStatement list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/bal_sheet"
                                render={(props) => (
                                    <BalanceSheet list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                path="/trial_balance"
                                render={(props) => (
                                    <TrialBalance list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            <AssistanceRoute
                                exact
                                path="/req_list"
                                render={(props) => (
                                    <RequisitionList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/req_execute/:req_no"
                                render={(props) => (
                                    <ReqExecute list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AssistanceRoute
                                exact
                                path="/pvt_reset_pass"
                                render={(props) => (
                                    <ResetPass list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            <BranchManagerRoute
                                exact
                                path="/"
                                component={Dashboard}
                                render={undefined}
                            />
                            <BranchManagerRoute
                                exact
                                path="/products_requisition"
                                render={(props) => (
                                    <ProductRequisition
                                        list={list}
                                        setList={setList}
                                        setActive={setActive}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <BranchManagerRoute
                                exact
                                path="/req_draft"
                                render={(props) => (
                                    <RequisitionDraft list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <BranchManagerRoute
                                exact
                                path="/req_history"
                                render={(props) => (
                                    <RequisitionHistory
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <BranchManagerRoute
                                exact
                                path="/br_reset_pass"
                                render={(props) => (
                                    <ResetPass list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            <FieldWorkerRoute
                                exact
                                path="/"
                                component={Dashboard}
                                render={undefined}
                            />
                            <FieldWorkerRoute
                                exact
                                path="/fwr_reset_pass"
                                render={(props) => (
                                    <ResetPass list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            <SalesRepresentativeRoute
                                exact
                                path="/"
                                component={Dashboard}
                                render={undefined}
                            />
                            <SalesRepresentativeRoute
                                exact
                                path="/sr_sells"
                                render={(props) => (
                                    <Sells
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <SalesRepresentativeRoute
                                exact
                                path="/sr_sell_reports"
                                render={(props) => (
                                    <SellReport list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <SalesRepresentativeRoute
                                exact
                                path="/sr_stock"
                                render={(props) => (
                                    <Stock
                                        setSupplierID={setSupplierID}
                                        SupplierID={SupplierID}
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <SalesRepresentativeRoute
                                exact
                                path="/sr_reset_pass"
                                render={(props) => (
                                    <ResetPass list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            <AdminRoute
                                exact
                                path="/"
                                component={Dashboard}
                                render={undefined}
                            />
                            {/* Business */}
                            <AdminRoute
                                exact
                                path="/bis_registration"
                                render={(props) => (
                                    <CreateCompany list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AdminRoute
                                exact
                                path="/bis_lists"
                                render={(props) => (
                                    <BisList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AdminRoute
                                exact
                                path="/usr_list"
                                render={(props) => (
                                    <UserLists list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AdminRoute
                                exact
                                path="/ad_backup"
                                render={(props) => (
                                    <Backup list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Supplier */}
                            <AdminRoute
                                exact
                                path="/bis_supplier_reg"
                                render={(props) => (
                                    <SupplierReg list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AdminRoute
                                exact
                                path="/bis_national_supplier_list"
                                render={(props) => (
                                    <NationalSuppliers list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AdminRoute
                                path="/adm_supplier_pro/:sup_id"
                                render={(props) => (
                                    <SupplierPro list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AdminRoute
                                exact
                                path="/adm_product_item/:sup_id/:id"
                                render={(props) => (
                                    <ProductItems list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <AdminRoute
                                exact
                                path="/adm_reset_pass"
                                render={(props) => (
                                    <ResetPass list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Reports */}
                            <PrivateRoute
                                path="/ucs_report"
                                render={(props) => (
                                    <UCSReport list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/ucs_party_report"
                                render={(props) => (
                                    <UCSPartyInvoiceList
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/bis_summery"
                                render={(props) => (
                                    <BisSummery list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/sale_n_purchase"
                                render={(props) => (
                                    <SalesPurchaseAnalysis
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/price_change_logs"
                                render={(props) => (
                                    <PriceChangeLog list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/cont_profit_assesment"
                                render={(props) => (
                                    <ProfitabilityAssesment
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/gst_on_sale"
                                render={(props) => (
                                    <GSTonSale list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/gst_on_purs"
                                render={(props) => (
                                    <GSTonPurchase list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/pei_transactions"
                                render={(props) => (
                                    <TransactionHistory
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/nill_stock_items"
                                render={(props) => (
                                    <NillStockItemUI list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Vendor & Providor */}
                            <PrivateRoute
                                path="/vendor_reg"
                                render={(props) => (
                                    <VendorRegistration
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/vendor_list"
                                render={(props) => (
                                    <VendorList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/vendor_main/:vend_id"
                                render={(props) => (
                                    <VendorMain list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/procure_list"
                                render={(props) => (
                                    <ProcureList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/procurement/:vend_id"
                                render={(props) => (
                                    <Procurement list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/procure_invoice_preview/:procure_id"
                                render={(props) => (
                                    <ViewProcure list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Payment Proccess */}
                            <PrivateRoute
                                path="/payment_requisition"
                                render={(props) => (
                                    <Requisition list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/payment_req_submission"
                                render={(props) => (
                                    <RequestSubmission list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/payment_req_list"
                                render={(props) => (
                                    <PaymentRequestList
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/payment_req_viewer/:req_id"
                                render={(props) => (
                                    <RequestViewer list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/create_advice/:req_id"
                                render={(props) => (
                                    <CreateAdvice list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/advice_list"
                                render={(props) => (
                                    <AdviceList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/advice_approval"
                                render={(props) => (
                                    <PendingAdviceList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/paid_invoices"
                                render={(props) => (
                                    <PaidInvoices list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* Promotion */}
                            {/* Order matters: edit first, then details, then list */}
                            <PrivateRoute
                                path="/promotional_programs/:id/edit"
                                render={(props) => (
                                    <FOCProgramEdit list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/promotional_programs/:id"
                                render={(props) => (
                                    <FOCProgramView list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                exact
                                path="/promotional_programs"
                                render={(props) => (
                                    <FOCProgramsList list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/create_promotional_programs"
                                render={(props) => (
                                    <CreateFOCProgram list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />

                            {/* FOC Trading */}
                            <PrivateRoute
                                path="/foc_trading"
                                render={(props) => (
                                    <FOCTradeItems list={list} setList={setList} {...props} />
                                )}
                                component={undefined}
                            />
                            <PrivateRoute
                                path="/foc_distribution_summary"
                                render={(props) => (
                                    <FOCDistributionSummary
                                        list={list}
                                        setList={setList}
                                        {...props}
                                    />
                                )}
                                component={undefined}
                            />

                            <Route path="/not_found" component={NotFound} />
                            <Route component={NotFound} />
                            <Redirect path="/" exact to="/home" />
                        </Switch>
                    </Suspense>
                </Layout>
            </Router>
        </Provider>
    );
};

export default App;
